import React from 'react';
import { ParallaxImage } from './ParallaxImage';
import { Button } from './Button';
export function StormDamage() {
  return <section id="storm-damage" className="relative py-24 lg:py-32 flex items-center" data-id="element-253">
      <div className="absolute inset-0 z-0" data-id="element-254">
        <ParallaxImage src="https://cdn.magicpatterns.com/uploads/obGSuCRT76CQUdcBVPrB6P/TXD-roofing1.jpg" alt="Texas Direct crew working on a storm damaged home with a branded yard sign" className="w-full h-full" overlayClassName="bg-tx-navy/90 mix-blend-multiply" data-id="element-255" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-256">
        <div className="max-w-3xl" data-id="element-257">
          <div className="inline-block px-4 py-1.5 bg-tx-red text-white font-bold rounded-full text-sm mb-6" data-id="element-258">
            Insurance Claim Experts
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight leading-tight" data-id="element-259">
            Storm Damage? We Handle the Insurance Claim.
          </h2>
          <p className="text-xl text-white/90 leading-relaxed mb-10 max-w-2xl" data-id="element-260">
            We've overseen more than 2,400 insurance claim roof replacements.
            Our team inspects your roof, documents the damage, and works with
            your insurance so you get the roof you deserve.
          </p>
          <Button className="bg-tx-red hover:bg-tx-red/90 text-white font-bold px-8 h-14 rounded-lg text-lg" data-id="element-261">
            Schedule a Roof Inspection
          </Button>
        </div>
      </div>
    </section>;
}